import { trackingService } from "../services/trackingService";
import { TrackingEvent, TrackingEventType } from "../types/tracking.types";
import utils from "../utils";
import { apiRequest, ApiResponse } from "./request";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export async function getBrowserFingerPrintId() {
  const ret = utils.getObject("BrowserFingerprintId");
  if (ret) {
    return ret;
  }
  let fid = "";
  try {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    if (visitorId) {
      fid = visitorId;
    }
  } catch (err) {
    console.warn("Failed to get browser fingerprint:", err);
  }
  const resp: ApiResponse<any> = await apiRequest(
    "/api/auth/browser_foot_print?t=" + (fid || ""),
    null,
    { method: "GET" }
  );
  const browserFingerprintId = resp?.data?.model;
  utils.setObject("BrowserFingerprintId", browserFingerprintId);
  return browserFingerprintId;
}

export async function reportHomeAppActive(
  browserFingerprintId: string,
  appType?: string
) {
  // 延迟到首屏渲染后再上报，避免与关键资源竞争连接池
  const doReport = async () => {
    if (appType === "h5" && !utils.getObject("landingAttributionReported")) {
      utils.setObject("landingAttributionReported", true);
      trackingService.trackLandingAttribution(browserFingerprintId).catch(err => {
        console.error("上报浏览器归因数据失败:", err);
      });
    }
    apiRequest(
      `/api/auth/browser_foot_print_active?bfId=${browserFingerprintId || ""}`,
      null,
      { method: "GET" }
    );
    if (utils.getObject("HomeAppActivePvTracked")) {
      return;
    }
    try {
      await trackingService.track(TrackingEvent.PV, TrackingEventType.PV, {
        eventDetail: "app active",
      });
      utils.setObject("HomeAppActivePvTracked", true);
    } catch (err) {
      console.error("埋点PV埋点失败:", err);
    }
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(() => doReport(), { timeout: 5000 });
  } else {
    setTimeout(doReport, 2000);
  }
}

export async function reportAdid(browserFingerprintId: string, adid: string) {
  apiRequest(
    `/api/auth/save_device_adid?bfId=${browserFingerprintId || ""}&adid=${adid || ""}`,
    null,
    { method: "GET" }
  );
  trackingService
    .track(TrackingEvent.PV, TrackingEventType.PV, {
      eventDetail: "app adid",
    })
    .catch(err => {
      console.error("埋点PV埋点失败:", err);
    });
}

// --- adid 与 bfid 双向等待绑定 ---
let _pendingAdid: string | null = null;
let _currentBfid: string | null = null;
let _adidBound = false;

function tryBindAdidToBfid() {
  if (_currentBfid && _pendingAdid && !_adidBound) {
    _adidBound = true;
    reportAdid(_currentBfid, _pendingAdid);
  }
}

/**
 * 页面获取到 bfid 后调用，触发绑定检查
 */
export function setCurrentBfid(bfid: string) {
  _currentBfid = bfid;
  tryBindAdidToBfid();
}

/**
 * android native 层获取到 adid 后调用，触发绑定检查
 */
window.onNativeAdidReady = function (adid: string) {
  _pendingAdid = adid;
  tryBindAdidToBfid();
};
